// extracted by mini-css-extract-plugin
export default {"deviceTypes":"TaskLocations_deviceTypes__wuY18"};